import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { HlsTimelineChart } from '@app/core/video-player/hls-timeline/HlsTimelineChart';
import { PlaybackVideoJsPlayer } from '@app/core/video-player/PlaybackVideoJsPlayer';
import { Box } from '@mui/material';
import { useMemo } from 'react';
import { useStreamSegmentsRange } from '../../../hooks/segments/useStreamSegmentsQuery';

const DEFAULT_WIDTH = 798;

/**
 * Logger-specific video player component.
 * Uses PlaybackVideoJsPlayer for store integration, adding Logger-specific
 * options (snapshot plugin, controlBar config) and styling.
 */
export function LoggerPlayer() {
  const station = useActiveStation();
  const range = useStreamSegmentsRange();

  const options = useMemo(
    () => ({
      playbackRates: [0.5, 1, 1.5, 2],
      controlBar: {
        playToggle: true,
        timeDivider: false,
        durationDisplay: false,
        remainingTimeDisplay: false,
        volumePanel: {
          inline: false,
          volumeControl: {
            vertical: true,
          },
        },
        pictureInPictureToggle: true,
      },
      userActions: {
        click: true,
      },
    }),
    [],
  );

  return (
    <>
      <Box
        sx={{
          width: DEFAULT_WIDTH,
          mx: 'auto',
          mt: 2,
        }}
        data-vjs-player
      >
        <PlaybackVideoJsPlayer
          options={options}
          playerClasses={['vjs-normalise-time-controls']}
          playerAttrs={{
            'data-station': station.slug,
            'data-station-name': station.name,
            'data-time-tz': station.timezone,
            'data-time-from': range.from.toString(),
            'data-time-to': range.to.toString(),
          }}
          enableSnapshotPlugin={true}
          bordered
        />
      </Box>
      <HlsTimelineChart />
    </>
  );
}
